__turbopack_context__.v({
  "hamburgerMenu": "hamburgerMenu-module-scss-module__58mjOq__hamburgerMenu",
  "menu": "hamburgerMenu-module-scss-module__58mjOq__menu",
  "menuButton": "hamburgerMenu-module-scss-module__58mjOq__menuButton",
});
